<template>
  <!-- Anchored to the avatar's right edge: Vuetify 2 clamped the 500px menu to the
       viewport, so it ended flush with the right margin; the v2 nudge-width only set a
       min-width the content already exceeded. -->
  <v-menu
    v-model="profileMenu"
    :close-on-content-click="false"
    location="bottom end"
  >
    <template #activator="{ props }">
      <v-btn
        variant="text"
        color="indigo"
        icon
        :ripple="false"
        class="ml-2"
        v-bind="props"
      >
        <v-avatar size="40">
          <v-img :src="userAvatar" :alt="userFullName" />
        </v-avatar>
      </v-btn>
    </template>
    <v-card min-width="320">
      <ProfileMenuContent @close="profileMenu = false" />
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

import { usePlaceholders } from '@/bundles/App/composables/usePlaceholders';

import ProfileMenuContent from '@/bundles/Panels/components/ProfileMenuContent.vue';

const store = useStore();
const { contactPlaceholder } = usePlaceholders();

const profileMenu = ref(false);

const userFullName = computed<string>(() => store.state.userName);
const userAvatar = computed<string>(() => store.state.user?.profile?.img || contactPlaceholder.value);
</script>
